/** Auto-generated by scripts/write-version.mjs — do not edit */
export const APP_VERSION = "1.1.7";
export const APP_VERSION_LABEL = "v1.1.7";
export const APP_BUILD_ID = "9c11c52";
export const APP_VERSION_FULL = "v1.1.7+9c11c52";
export const APP_BUILT_AT = "2026-10-31T14:11:58.252Z";
export const APP_GIT_SHA = "9c11c52";
export const APP_GIT_COMMIT_COUNT = "1";
